export default __webpack_public_path__ + "static/media/MICROSOFT_AZURE.1e38cc0e.png";